import { combineReducers } from 'redux';
import user from './user';
import featuredEvent from './featuredEvent';

export default combineReducers({
  user,
  featuredEvent,
});
